import {
    PATH_COLABORADOR_DETAIL,
    PATH_CONSIGNA_DETAIL,
    PATH_CONTACTO_DETAIL,
    PATH_CUENTA_DETAIL,
    PATH_BUSCADOR,
    PATH_AGENDA
} from '../../../navigation/navigation.module';
import { environment } from '../../../../environments/environment';
import { AfterViewInit, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../services/navigation-service';
import { SearchService, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_CUENTA, SEARCH_TYPE_CONSIGNA } from '../../../services/search-service';
import {
  CuentasService,
  CUENTA_TYPE_CLIENTE,
  CUENTA_TYPE_PROSPECTO,
  CUENTA_TYPE_PROVEEDOR
} from '../../../services/cuentas-service';
import { PermisosService, PERM_ACCIONES_ID } from '../../../services/permisos-service';
import { DialogsService } from '../../../services/dialogs-service';
import { AgendaService } from '../../../services/agenda-service';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { TableDataSource } from '../../../utils';
import * as moment from 'moment';

@Component({
  selector: 'app-buscador',
  templateUrl: './buscador.component.html',
  styleUrls: ['./buscador.component.scss']
})
export class BuscadorComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('searchInput') searchInput;
  searchControl;
  searchTerm: string = '';

  cuentasSubject$ = new BehaviorSubject<any[]>([]);
  cuentasDataSource = new TableDataSource(this.cuentasSubject$);
  cuentasDisplayedColumns = ['fullName', 'actions'];
  cuentasPage = 0;
  cuentasResponseData = [];

  colaboradoresSubject$ = new BehaviorSubject<any[]>([]);
  colaboradoresDataSource = new TableDataSource(this.colaboradoresSubject$);
  colaboradoresDisplayedColumns = ['fullName', 'lastConnectedTime', 'actions'];
  colaboradoresPage = 0;
  colaboradoresResponseData = [];

  consignasSubject$ = new BehaviorSubject<any[]>([]);
  consignasDataSource = new TableDataSource(this.consignasSubject$);
  consignasDisplayedColumns = ['title', 'date', 'actions'];
  consignasPage = 0;
  consignasResponseData = [];

  cuentasFilters = {
    ColaboradoresId:[],
    EtiquetasIds: [],
    ActivosPrimero: false
  };

  colaboradoresFilters = {
    CuentasIds: [],
    ActivosPrimero: false
  };

  consignasFilter = {
    CuentasIds: [],
    MotoresIds: [],
    ColaboradoresIds: [],
    From: moment().startOf('day').toDate(),
    To: moment().startOf('day').add(1,'M').toDate(),
    MyNetwork: false
  };

  selectedTabIndex = 0;

  currentUserId = Number(localStorage.getItem('userId'));

  cuentaTypeProspecto = CUENTA_TYPE_PROSPECTO;
  cuentaTypeProveedor = CUENTA_TYPE_PROVEEDOR;
  cuentaTypeCliente = CUENTA_TYPE_CLIENTE;

  ASSETS_URL = environment.ASSETS_URL;

  private scrollSubscriber;

  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  constructor(private cuentasService: CuentasService,
              private searchService: SearchService,
              private router: Router,
              private dialogsService: DialogsService,
              private agendaService: AgendaService,
              private location: Location,
              private route: ActivatedRoute,
              private navService: NavigationService,
              private permisosService: PermisosService) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      let page = this.route.snapshot.params['page'];

      switch(page){
        case 'colaboradores':
          this.selectedTabIndex = 0;
          break;
        case 'cuentas':
          this.selectedTabIndex = 1;
          break;
        case 'consignas':
          this.selectedTabIndex = 2;
          break;
      }
    });

    this.searchControl = new FormControl();
    this.searchControl.valueChanges
    .startWith(null)
    .debounceTime(1000)
    .subscribe(value => {
      //if (value){
        this.colaboradoresPage = 0;
        this.cuentasPage = 0;
        this.consignasPage = 0;

        if(this.selectedTabIndex == 0){
          this.searchColaboradores();
        }

        if(this.selectedTabIndex == 1){
          this.searchCuentas();
        }

        if(this.selectedTabIndex == 2){
          this.searchConsignas();
        }
        /*
        this.searchCuentas();
        this.searchColaboradores();
        this.searchConsignas();
        */
      //}
    })
  }

  searchCuentas(){
    this.searchService.search(this.searchTerm, SEARCH_TYPE_CUENTA, this.cuentasPage, this.cuentasFilters)
      .subscribe( data => {
        if (this.cuentasPage === 0){
          this.cuentasResponseData = this.formatCuentas(data);
        } else {
          this.cuentasResponseData = [ ...this.cuentasResponseData, ...this.formatCuentas(data) ];
        }
        this.cuentasSubject$.next(this.cuentasResponseData);
      }, err => {
        console.log(err);
      });
  }

  searchColaboradores(){
    this.searchService.search(this.searchTerm, SEARCH_TYPE_COLABORADOR, this.colaboradoresPage, this.colaboradoresFilters)
      .subscribe( data => {
        if (this.colaboradoresPage === 0){
          this.colaboradoresResponseData = data;
        } else {
          this.colaboradoresResponseData = [ ...this.colaboradoresResponseData, ...data ];
        }
        this.colaboradoresSubject$.next(this.colaboradoresResponseData);
      }, err => {
        console.log(err);
      });
  }

  searchConsignas(){

    this.searchService.search(this.searchTerm, SEARCH_TYPE_CONSIGNA, this.consignasPage, this.consignasFilter)
      .subscribe( data => {
        data.forEach(c => {
          c.showOwnerButtons = this.currentUserId === c.UsuarioCreadorId;
          c.isSameDay = moment(c.FechaFrom*1000).isSame(moment(c.FechaTo*1000), 'day');
        });
        if (this.consignasPage === 0){
          this.consignasResponseData = data;
        } else {
          this.consignasResponseData = [ ...this.consignasResponseData, ...data ];
        }
        this.consignasSubject$.next(this.consignasResponseData);
      }, err => {
        console.log(err);
      });
  }

  selectTab(e) {
    let pages = ['/colaboradores', '/cuentas', '/consignas']

        if(this.selectedTabIndex == 0){
          this.searchColaboradores();
        }

        if(this.selectedTabIndex == 1){
          this.searchCuentas();
        }

        if(this.selectedTabIndex == 2){
          this.searchConsignas();
        }

    this.location.go(PATH_BUSCADOR+pages[e]);
  }

  onCuentaSelected(cuenta){
    this.router.navigate([PATH_CUENTA_DETAIL, cuenta.Id]);
  }

  onColaboradorSelected(colaborador){
    this.router.navigate([PATH_COLABORADOR_DETAIL, colaborador.UserId]);
  }

  onContactoSelected(contacto){
    this.router.navigate([PATH_CONTACTO_DETAIL, contacto.ClientContactId]);
  }

  onConsignaSelected(consigna){
    this.router.navigate([PATH_CONSIGNA_DETAIL, consigna.ConsignaId]);
  }

  onActivateCuenta(cuenta, activate: boolean){
    this.dialogsService.confirm(null,
                activate ? "¿Está seguro de que desea activar esta cuenta?" : "¿Está seguro de que desea desactivar esta cuenta?",
                activate ? "SÍ, ACTIVAR" : "SÍ, DESACTIVAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.cuentasService.activateCuenta(cuenta.Id)
            .subscribe( data => {
              if (data.ResponseData){

                for (let empresa of this.cuentasResponseData){
                  if (empresa.Entity.Id === cuenta.Id){
                    empresa.Entity.Habilitada = activate;
                    this.cuentasSubject$.next(this.cuentasResponseData);
                    return;
                  }
                }
              }
            });
        }});
  }

  showNewConsignaDialogForCuenta(cuenta){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', null, cuenta);
  }

  showNewConsignaDialogForColaborador(colaborador){
    console.log(colaborador);

    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', colaborador, null);
  }

  showNewConsignaDialogForContacto(contacto){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', null, null, contacto);
  }

  showEditContactoDialog(contacto){
    this.dialogsService.showNewContactoDialog(
      null,
      contacto,
      'GUARDAR',
      'CANCELAR'
    ).subscribe( () => {
        this.searchCuentas();
    });
  }

  onDeleteContacto(contacto){
    this.dialogsService.confirm(null,
                "¿Está seguro de que desea eliminar este contacto?",
                "SÍ, ELIMINAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.cuentasService.deleteContacto(contacto.ClientContactId)
            .subscribe( data => {
              this.cuentasResponseData.splice(this.cuentasResponseData.findIndex(val => val.Entity.ClientContactId === contacto.ClientContactId),1);
              this.cuentasSubject$.next(this.cuentasResponseData);
            });
        }});
  }

  onDeleteCuenta(cuenta){
    this.dialogsService.confirm(null,
                "¿Está seguro de que desea eliminar esta cuenta?",
                "SÍ, ELIMINAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.cuentasService.deleteCuenta(cuenta.Id)
            .subscribe( data => {
              if (data.ResponseData){
                this.cuentasResponseData.splice(this.cuentasResponseData.findIndex(val => val.Entity.Id === cuenta.Id), 1);
                this.cuentasSubject$.next(this.cuentasResponseData);
              }
            });
        }});
  }

  navigateBack(){
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/'+PATH_AGENDA);
    }
  }

  onColaboradoresFiltersApplied($event){
    console.log($event);
    this.colaboradoresPage = 0;

    let selectedCuentasArray = Array.from($event.cuentas).map(item => (item as any).Id);

    this.colaboradoresFilters = {
      CuentasIds: selectedCuentasArray,
      ActivosPrimero: $event.moreActiveFirst
    };

    this.searchColaboradores();
  }

  onCuentasFiltersApplied($event){
    console.log($event);
    this.cuentasPage = 0;

    let selectedColaboradoresArray = Array.from($event.colaboradores).map(item => (item as any).UserId);
    let selectedEtiquetasArray = Array.from($event.etiquetas).map(item => (item as any).Id);

    this.cuentasFilters = {
      ColaboradoresId: selectedColaboradoresArray,
      ActivosPrimero: $event.moreActiveFirst,
      EtiquetasIds: selectedEtiquetasArray
    };

    this.searchCuentas();
  }

  onFinishConsigna(consigna){
    this.dialogsService.showRateConsignaDialog()
      .subscribe( res => {
          if (res){
            this.agendaService.rateConsigna(consigna.ConsignaId, res)
              .subscribe( data => {
                consigna.EstadoConsigna = 'Realizada';
              });
          }
      });
  }

  onDeleteConsigna(consigna){
    this.dialogsService.confirm(null,
                "¿Está seguro de que desea eliminar esta consigna?",
                "SÍ, ELIMINAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.agendaService.deleteConsigna(consigna.ConsignaId)
            .subscribe( data => {
              this.consignasResponseData.splice(this.consignasResponseData.findIndex(val => val.Entity.ConsignaId === consigna.ConsignaId), 1);
              this.consignasSubject$.next(this.consignasResponseData);
            });
        }});
  }

  onConsignasFiltersApplied($event){
    console.log($event);
    this.consignasPage = 0;

    let selectedColaboradoresArray = Array.from($event.colaboradores).map( item => (item as any).UserId);

    let selectedCuentasArray = Array.from($event.cuentas).map(item => (item as any).Id);

    let selectedMotoresArray = []; //Array.from($event.motores).map(item => (item as any).Id);

    this.consignasFilter = {
      CuentasIds: selectedCuentasArray,
      MotoresIds: selectedMotoresArray,
      ColaboradoresIds: selectedColaboradoresArray,
      From: $event.startDate,
      To: $event.endDate,
      MyNetwork: $event.myNetwork
    };

    this.searchConsignas();
  }

    public ngAfterViewInit(): void {

      const content = document.querySelector('.mat-drawer-content');

      this.searchInput.nativeElement.focus();

      this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
        .debounceTime(300)
        .map(() => content.scrollTop)
        .subscribe(x => {
          let max = content.scrollHeight - content.clientHeight;

          if ( x > max * 0.7){

            switch(this.selectedTabIndex){
              case 0:
                this.colaboradoresPage ++;
                this.searchColaboradores();
                break;
              case 1:
                this.cuentasPage ++;
                this.searchCuentas();
                break;
              case 2:
                this.consignasPage ++;
                this.searchConsignas();
                break;
            }
          }
        });
    }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  formatCuentas(cuentas) {
    cuentas.forEach(emp => {
      if (emp.Entity.CuentaAcopio) {
        emp.Entity.cuentasAcopios = '';
        emp.Entity.CuentaAcopio.forEach(e => {
          if (e.CuentaAcopio !== 0) {
            emp.Entity.cuentasAcopios += e.CuentaAcopio.toString() + ', ';
          }
        });
        if (emp.Entity.cuentasAcopios.length) {
          emp.Entity.cuentasAcopios = emp.Entity.cuentasAcopios.slice(0, -2);
        }
      }
    });
    return cuentas;
  }

  permisoAutorizado(id) {

  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/buscador/buscador/buscador.component.ts